export default "__VITE_ASSET__DLeM0jUh__"